enum SearchService {
  KALIMAT = 'kalimat',
  QDC = 'qdc',
  Tarteel = 'tarteel',
}

export default SearchService;
